// extracted by mini-css-extract-plugin
export var readonly = "_h3-1";
export var star = "_h3-0";